export enum SearchModeType {
  'ai' = 'ai',
  'regular' = 'regular',
}

export const SEARCH_MODE_TYPES = [
  { value: SearchModeType.ai, label: 'Умный поиск' },
  { value: SearchModeType.regular, label: 'Обычный поиск' },
];
